import { render, staticRenderFns } from "./MapHeightmap.vue?vue&type=template&id=34a984f6&scoped=true"
import script from "./MapHeightmap.vue?vue&type=script&lang=js"
export * from "./MapHeightmap.vue?vue&type=script&lang=js"
import style0 from "./MapHeightmap.vue?vue&type=style&index=0&id=34a984f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a984f6",
  null
  
)

export default component.exports